import type React from 'react'
import { useState } from 'react'
import { Textarea } from '~/shared/ui/textarea'
import { FormField } from './form-field'

interface FormTextareaProps {
  // biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API is dynamically typed
  field: any
  label: string
  placeholder?: string
  optional?: boolean
  rows?: number
  labelAction?: React.ReactNode
}

export function FormTextarea({
  field,
  label,
  placeholder,
  optional,
  rows = 5,
  labelAction,
}: FormTextareaProps) {
  const [hasBlurred, setHasBlurred] = useState(false)

  return (
    <FormField
      field={field}
      label={label}
      optional={optional}
      hasBlurred={hasBlurred}
      labelAction={labelAction}
    >
      <Textarea
        id={field.name}
        name={field.name}
        value={field.state.value || ''}
        onBlur={() => {
          setHasBlurred(true)
          field.handleBlur()
        }}
        onChange={(e) => field.handleChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
      />
    </FormField>
  )
}
